// extracted by mini-css-extract-plugin
module.exports =  {"alert":"P02KuiswTmMia88o2GE9"};